import { Component } from '@angular/core';
import { VirtualPassComponent } from 'libs/shared/src/lib/component/order/order-virtual-pass/order-virtual-pass.component';

@Component({ standalone: false, selector: 'app-order-virtual-pass', templateUrl: './order-virtual-pass.component.html' })
export class CustomVirtualPassComponent extends VirtualPassComponent {}
